"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PaymentGatewayEnum;
(function (PaymentGatewayEnum) {
    PaymentGatewayEnum["SBER_PROD"] = "SBER_PROD";
    PaymentGatewayEnum["SBER_TEST"] = "SBER_TEST";
    PaymentGatewayEnum["YOOKASSA"] = "YOOKASSA";
})(PaymentGatewayEnum = exports.PaymentGatewayEnum || (exports.PaymentGatewayEnum = {}));
var PaymentGatewayNameEnum;
(function (PaymentGatewayNameEnum) {
    PaymentGatewayNameEnum["SBER_PROD"] = "\u0421\u0431\u0435\u0440\u0431\u0430\u043D\u043A \u0431\u043E\u0435\u0432\u043E\u0439";
    PaymentGatewayNameEnum["SBER_TEST"] = "\u0421\u0431\u0435\u0440\u0431\u0430\u043D\u043A \u0442\u0435\u0441\u0442\u043E\u0432\u044B\u0439";
    PaymentGatewayNameEnum["YOOKASSA"] = "YooKassa";
})(PaymentGatewayNameEnum = exports.PaymentGatewayNameEnum || (exports.PaymentGatewayNameEnum = {}));
//# sourceMappingURL=PaymentGatewayEnum.js.map